import * as React from "react";
import SideBarContainer from "../layouts/sideBar.container";

declare const window: any;

export default function GaleriesContainer({
  data,
  isPortrait,
  original,
  setSpinSelected,
  setGaleriaSelected,
  menuSelected,
  subMenuSelected,
  setSubMenuSelected,
  subMenuSelectedTemp,
  setMenuSelected,
  theme,
  isSelected,
  setIsSelected,
  icono,
  colors,
  setFrame,
  isSideBar,
  setIsSideBar,
  setHotspotsSelected,
  version,
  isSelectedAptoView,
  setIsSelectedAptoView,
}: any) {
  return (
    <div className={`townplanning-container`}>
      <SideBarContainer
        data={data}
        isPortrait={isPortrait}
        original={original}
        setSpinSelected={setSpinSelected}
        setGaleriaSelected={setGaleriaSelected}
        theme={theme}
        isSideBar={isSideBar}
        setIsSideBar={setIsSideBar}
        menuSelected={menuSelected}
        subMenuSelected={subMenuSelected}
        setSubMenuSelected={setSubMenuSelected}
        subMenuSelectedTemp={subMenuSelectedTemp}
        setMenuSelected={setMenuSelected}
        icono={icono}
        isSelected={isSelected}
        setIsSelected={setIsSelected}
        colors={colors}
        setFrame={setFrame}
        setHotspotsSelected={setHotspotsSelected}
        version={version}
        isSelectedAptoView={isSelectedAptoView}
        setIsSelectedAptoView={setIsSelectedAptoView}
      />
    </div>
  );
}
